import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

export enum Signal {
  SIGNAL_REFRESH_DRAFTS = 'SIGNAL_REFRESH_DRAFTS',
  SIGNAL_REFRESH_METADATA = 'SIGNAL_REFRESH_METADATA',
  SIGNAL_SHOW_MASK_VIEWER_PANE = 'SIGNAL_SHOW_MASK_VIEWER_PANE',
  SIGNAL_HIDE_MASK_VIEWER_PANE = 'SIGNAL_HIDE_MASK_VIEWER_PANE',
}

/**
 * Generic signal-sending service for communicating between components.
 *
 * Example use:
 *
 * Emitter:
 *
 * ```
 *   this.signalService.sendSignal(Signal.SIGNAL_CONSTANT_KEY)
 * ```
 *
 * Consumer:
 *
 * ```
    override ngOnInit () {
      this.signalSubscription = this.signalService.getSignal().subscribe(signal => {
        if (signal === Signal.SIGNAL_CONSTANT_KEY) {
          // do something
        }
      })
    }

    override ngOnDestroy () {
      this.signalSubscription?.unsubscribe()
    }
 * ```
 */
@Injectable({ providedIn: 'root' })
export class SignalService {
  private readonly signal = new Subject<Signal>()

  sendSignal (signal: Signal) {
    this.signal.next(signal)
  }

  getSignal () {
    return this.signal.asObservable()
  }
}
